import { Pipe, PipeTransform } from '@angular/core';
import { get } from 'lodash-es';
import { Option } from '../types';

@Pipe({ name: 'get' })
export class GetPipe implements PipeTransform {
  transform(option: Option, path: string = null): string {
    return get(option, path, '');
  }
}
